export function formatDate(date: number): string {
  if (!date) return '';

  const dateString = date.toString();

  if (dateString.length === 8) {
    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6);
    const day = dateString.slice(6, 8);

    return `${year}-${month}-${day}`;
  }

  // If date is invalid, return empty string instead of throwing error
  return '';
}

export function formattedDateFromNumber(date: number) {
  if (!!date) {
    const dateString = date.toString();
    return (
      dateString.substring(4, 6) +
      '/' +
      dateString.substring(6, 8) +
      '/' +
      dateString.substring(0, 4)
    );
  }
  return 'MM/DD/YYYY';
}
